import { FC } from 'react'

interface IProps {
  onAccept: () => void
}

export const RiskProfileWarningModal: FC<IProps> = ({ onAccept }) => (
  <div
    className='position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center'
    style={{ background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
  >
    <div className='card p-8 position-relative' style={{ maxWidth: 460 }}>
      <button
        type='button'
        className='btn-close position-absolute top-0 end-0 m-4'
        aria-label='Cerrar'
        onClick={onAccept}
      ></button>
      <div
        className='d-flex align-items-center justify-content-center mx-auto mb-4'
        style={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          backgroundColor: 'rgba(0, 123, 195, 0.1)',
        }}
      >
        <i className='bi bi-exclamation-triangle text-primary' style={{ fontSize: '1.5rem' }}></i>
      </div>
      <h3 className='text-center mb-4'>Fondo no alineado al perfil de riesgo</h3>
      <p className='text-center text-muted mb-6'>
        El fondo seleccionado no corresponde al perfil de tolerancia al riesgo del cliente. Al
        continuar, confirmas que el cliente ha sido informado de esta condición y ha autorizado la
        operación bajo su propia responsabilidad, liberando a PrudentialSAF Sociedad Administradora
        de Fondos S.A.C. de toda responsabilidad.
      </p>
      <button type='button' className='btn btn-solid-primary w-100' onClick={onAccept}>
        Aceptar
      </button>
    </div>
  </div>
)
